export default __webpack_public_path__ + "static/chart-customisation-4012b1add495675a22a93de369a3ea61.png";